import { render, staticRenderFns } from "./ThePaintings.vue?vue&type=template&id=40691322&scoped=true"
import script from "./ThePaintings.vue?vue&type=script&lang=js"
export * from "./ThePaintings.vue?vue&type=script&lang=js"
import style0 from "./ThePaintings.vue?vue&type=style&index=0&id=40691322&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40691322",
  null
  
)

export default component.exports